<template>
	<b-modal :visible="Visible" @hide="onClose();" @close="onClose();" size="xl" centered no-close-on-backdrop no-close-on-esc @hidden="clearPFilter();" :style="generateVariantStyle(Variant)" >
		<template #modal-title>			
			<!-- $t('FilteredByProperties') / Filtres par propriétés -->
			<b-row align-v="center" class="w-100 m-0" >
				<b-col class="p-0">
					<h6 class="m-0 text-nowrap">{{ $t('FilteredByProperties') }}</h6>         
				</b-col>
				<b-col cols="auto" class="p-0 pl-2">
					<!-- On les affiche si au moins un type de pin est renseigné -->
					<b-button-group v-if="PropertiesFilterPinTypes.length > 0" class="btn-gray-light rounded-pill border border-gray" size="sm">
						<!-- Mode défaut : sélection de filtres sur l'ensemble de l'arborescence -->
						<b-button v-if="PropertiesFilterPinTypes.includes(PinTypeEnum.None)" v-b-tooltip.hover :title="$t('Default')" variant="outline-white" pill
							@click="propertyType = PinTypeEnum.None"  :pressed="propertyType === PinTypeEnum.None" :class="propertyType === PinTypeEnum.None ? 'border-gray-dark' : ''">
							<b-icon icon="list-nested"/>
						</b-button>
						<!-- Mode recherche noeud : sélection de filtres à partir du noeud recherché -->
						<b-button v-if="PropertiesFilterPinTypes.includes(PinTypeEnum.Tree)" v-b-tooltip.hover :title="$t('SearchNode')" variant="outline-white" pill
							@click="propertyType = PinTypeEnum.Tree" :pressed="propertyType === PinTypeEnum.Tree" :class="propertyType === PinTypeEnum.Tree ? 'border-gray-dark' : ''" >
							<b-icon icon="search" />
						</b-button>
						<!-- Mode périmètre utilisateur : sélection de filtres sur le périmètre utilisateur -->
						<b-button v-if="PropertiesFilterPinTypes.includes(PinTypeEnum.Root)" v-b-tooltip.hover :title="$t('UserPerimeter')" variant="outline-white" pill
							@click="propertyType = PinTypeEnum.Root" :pressed="propertyType === PinTypeEnum.Root" :class="propertyType === PinTypeEnum.Root ? 'border-gray-dark' : ''">
							<b-icon icon="diagram3" />
						</b-button>
					</b-button-group>
				</b-col>
			</b-row>
		</template>

		<template>
			<!-- Affichage du module de recherche -->
			<b-row v-if="propertyType === PinTypeEnum.Tree" >
				<b-col>
					<NodesSelector :Pins.sync="searchPins" :Preview="false" :SearchReadOnly="true" />
					<hr />
				</b-col>
			</b-row>

			<!-- Permet l'effacement des filtres par propriétés quand on est en mode "recherche noeud" -->
			<b-row v-if="propertyType === PinTypeEnum.Tree && Object.keys(selectType).length > 0" align-h="end">
				<b-col cols="auto" class="pb-2">
					<b-link @click="clearPFilter(false)" class="text-danger px-2">{{ $t('ErasePropertiesFilter') }}</b-link>
				</b-col>
			</b-row>

			<!-- // Filtre principal // -->
			<b-row align-v="center" class="pb-2" :style="generateVariantStyle(Variant)" > <!-- :style="generateVariantStyle(Variant)" -->
				<b-col cols="auto" align-self="end">
					<!-- Ajout d'un sous filtre -->
					<span :id="$id('AddSubFilter')">
						<b-button :variant="Variant" @click="addSubFilter(selectType, subFilters)" :disabled="Object.keys(selectType).length == 0 || noSubFilterAvailable" >
							<b-icon icon="plus"/>
						</b-button>
					</span>

					<!-- Tooltip indiquant si on peut ajouter ou non un sous-filtre -->
					<b-tooltip :target="$id('AddSubFilter')" noninteractive placement="right" triggers="hover">
						{{ Object.keys(selectType).length == 0 || noSubFilterAvailable ? $t('NoSubFiltersAvailable') : $t('AddSubFilter') }}
					</b-tooltip>
				</b-col>
				<b-col>
					<!-- Type d'objet -->
					<label>{{$t('ObjectType')}}</label>
					<multiselect :id="$id('MainObjectType')"
						:options="getObjectLabel()"
						:disabled="false"
						:required="false"
						:close-on-select="true"
						:allow-empty="false"
						:searchable="true"
						:show-labels="false"
						:multiple="false"
						:max-height="150"
						track-by="Id"
						label="Label"
						:placeholder="$t('SelectObjectType')"
						class="mt-0 mb-0 ml-0 mr-3 pt-0 d-inline-block h-100"
						style="background: white !important; background-color: white !important"
						v-model="selectType"
						@input="updateConstraints">
						<template #caret={toggle}>
							<span class="multiselect__select pr-0">
								<b-icon icon="chevron-down" font-scale="0.55" shift-h="0" style="stroke: black !important; stroke-width: 1.5px !important;"/>
							</span>
						</template>
						<template #noResult>
							{{ $t('NoMatchingObjectType') }}
						</template>
					</multiselect>
				</b-col>
			</b-row>

			<!-- Gestion des critères sur le filtre principal -->
			<CriteriasPropertyFilter v-if="selectType && Object.keys(selectType).length > 0 && (properties[selectType.Extras.Name] && properties[selectType.Extras.Name].length > 0)" :Criterias.sync="criterias" :Logicals="logicals" :Properties="properties" :SelectType="selectType.Extras.Name" :Variant="Variant" />

			<!-- Message lorsque que le type d'objet ne possède pas de critère -->
			<b-row v-else-if="selectType && Object.keys(selectType).length > 0 && (properties[selectType.Extras.Name] && properties[selectType.Extras.Name].length == 0)">
				<b-col class="text-muted">
					{{ $t('NoCriteriaAvailable') }}
				</b-col>
			</b-row>	

			<hr v-if="subFilters && subFilters.length > 0" />

			<!-- // Sous-filtres // -->
			<template v-for="(subFilter,index) in subFilters">
				<b-row class="w-100 ml-1" :style="generateVariantStyle(Variant)" >
					<!-- Opérateur logique entre les sous-filtres -->
					<b-col cols="1" align-self="end">
						<b-form-select size="sm" v-if="index > 0" :options="logicals" v-model="subFilter.Operande" value-field="Name" text-field="Label" />
					</b-col>

					<b-col cols="1" align-self="end">
						<!-- $t('DeleteSubFilter') / Suppression du sous filtre -->
						<b-button @click="removeSubFilter(subFilters, index)" :variant="Variant" v-b-tooltip.noninteractive.hover :title="$t('DeleteSubFilter')"><b-icon icon="dash"/></b-button>
					</b-col>
					
					<b-col>
						<label>{{$t('ObjectType')}}</label>
						<multiselect :id="$id('SubObjectType')"
							:options="constraintOptions"
							:disabled="false"
							:required="false"
							:close-on-select="true"
							:allow-empty="false"
							:searchable="true"
							:show-labels="false"
							:multiple="false"
							:max-height="150"
							track-by="value"
							label="text"
							:placeholder="$t('SelectObjectType')"
							class="mt-0 mb-0 ml-0 mr-3 pt-0 d-inline-block h-100"						
							:value="constraintOptions.find(c => c.value === subFilter.Type)"
							@input="(selectedOption) => updateSubFilter(selectedOption, subFilter, index)">
							<template #caret={toggle}>
								<span class="multiselect__select pr-0">
									<b-icon icon="chevron-down" font-scale="0.55" shift-h="0" style="stroke: black !important; stroke-width: 1.5px !important;"/>
								</span>
							</template>

							<template #noResult>
								{{ $t('NoMatchingObjectType') }}
							</template>
						</multiselect>
					</b-col>
				</b-row>
				
				<!-- Gestion des critères sur un sous-filtres -->
				<CriteriasPropertyFilter v-if="subFilter.Type && (properties[subFilter.Type] && properties[subFilter.Type].length > 0)" :Criterias.sync="subFilter.Criterias" :Logicals="logicals" :Properties="properties" :SelectType="subFilter.Type" :Variant="Variant" class="w-100 pt-2" />
			</template>
		</template>

		<template #modal-footer="{ cancel }">
			<!-- $t('Cancel') / Annuler -->
			<b-button :variant="'outline-' + Variant" pill @click="resetPin(); cancel();">{{ $t('Cancel') }}</b-button>
			<!-- $t('Add') / Ajouter -->
			<b-button :variant="Variant" pill :disabled="(!selectType || Object.keys(selectType).length ==0) || !(criterias && criterias.every(c => c.Operator != '' && c.Value != ''))" @click="saveFilter(); cancel();">{{ $t('Add') }}</b-button>
		</template>

	</b-modal>
</template>

<script lang="ts">
	import { Component, InjectReactive, Model, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
	import { mixins } from 'vue-class-component';
	import { Getter } from 'vuex-class';
	import axios from 'axios';
	import { API_URL } from '@/App.settings';
	import Dictionary from '@/types/Dictionary';
	import ListItem from "@/types/fields/ListItem";
	import Property from '@/types/Property';
	import Criteria from '@/types/FilterTree/Criteria';
	import PinTypeEnum from '@/enums/PinTypeEnum';
	import Pin from '@/types/FilterTree/Pin';
	import SubFilter from '@/types/FilterTree/SubFilter';
	import CriteriasPropertyFilter from './CriteriasPropertyFilter.vue';
	import Multiselect from 'vue-multiselect';
	import { ThemeUtils } from '../Utils';
	import locales from "../locales/PropertiesFilter.json"
	import NodesSelector from '../Dashboard/SimpleConfig/NodesSelector.vue';

	/** Composant d'ajout de filtre par propriétés de type d'objet */
	@Component({
		components: {
			CriteriasPropertyFilter,
			Multiselect,
			NodesSelector
		},
		i18n: {messages: locales}
	})
	export default class PropertiesFilter extends mixins(ThemeUtils) {
		/** Variant de couleur à appliquer sur le composant */
		@InjectReactive()
        public Variant!: string;

		/** Nom du store Vuex persistant l'arborescence */
		@Prop()
		public FilterTreeStore!: string;

		/** Pin à réafficher pour modification */
		@PropSync('Pin', { default: () => {}})
		public lPin!: Pin;		

		@Prop({default: () => []})
		public PropertiesFilterPinTypes!: PinTypeEnum[];

		@Prop({ default: undefined })
		public PropertiesFilterObjectTypes!: string[];

		/** Getter afin de récupérer une liste selon un nom spécifique */
		@Getter('GetListItems')
		private listItems!: (listName: string) => ListItem[];

		/** @todo : mettre affichage/masquage modale par v-model dans une classe commune à hériter ? */
		// Affichage/masquage de la modale par v-model
        @Model('PropertiesFilterVisibleEvent', { default: false }) /** type: boolean, */
		public Visible!: boolean;
		private visible: boolean = false;

		@Watch('Visible')
        private updateVisible() {
            this.visible = this.Visible;
        }

		/** Type d'objet sélectionné */
		private selectType: ListItem = {} as ListItem;

		/** Dictionnaire des propriétés du type objet */
		private properties: Dictionary<Property[]> = {};

		/** Liste des contraintes d'un type d'objet */
		private constraintOptions : {value: string, text: string}[] = [];

		/** Liste des critères sélectionné dans le filtre */
		private criterias: Criteria[] = [];

		/** Tableau des différents filtres renseignés */
		private subFilters : SubFilter[] = [];

		/** Permet d'indiquer si l'objet sélectionné a la possibilité d'avoir des sous-filtres */
		private noSubFilterAvailable : boolean = false;

		/** Liste des types de recherches possibles (ici par nom et le périmètre utilisateur) */
		private PinTypeEnum = PinTypeEnum;
		private propertyType: PinTypeEnum = PinTypeEnum.None;

		/** Liste des Pin lié à la recherche */
		private searchPins : Pin[] = [];

		/** Opérateurs logiques
		 * @todo : A charger dynamiquement ???
		 * */
		private logicals: { Name: string, Label: string }[] = [
			{ Name: 'And', Label: this.$t('And').toString().toUpperCase() }, // $t('And') / Et
			{ Name: 'Or', Label: this.$t('Or').toString().toUpperCase() }]; // $t('Or') / Ou

		/** Permet d'obtenir la liste des type d'objet avec leur traduction */
		private getObjectLabel() {
			let objectTypes: ListItem[] = undefined;
			if(this.PropertiesFilterObjectTypes){
				objectTypes = this.listItems('ObjectType').filter(x => this.PropertiesFilterObjectTypes.includes(x.Extras.Name));
			}else{
				objectTypes = this.listItems('ObjectType').filter(x => Object.keys(this.properties).filter(y => y.toString() == x.Id.toString()));
			}

			console.debug("PropertiesFilter - getObjectLabel - objectTypes : %O - this.properties : %O", objectTypes, this.properties);

			return objectTypes;
		}

		/** Permet d'obtenir la liste des contraintes selon un type
		 * @param type type d'objet sélectionné
		 */
		private async getConstraintsLabel(type : string) {
			// On vide la liste actuelle
			this.constraintOptions = [];

			const args: Dictionary<any> = {};
			args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
			args["ObjectType"] = type;

			// Récupération des contraintes coté serveur
			await axios.post(API_URL + "FilterTree/GetObjectConstraints", args).then((response) => {
				let constraints = response.data;

				console.debug("PropertiesFilter - getConstraintsLabel - response.data : %O", response.data);

				// Si l'objet sélectionné possède des contraintes, on les parcourt pour créer la liste 
				if(constraints.at(0) != "None")
					this.constraintOptions = constraints
						.map(name => {
							let item : ListItem = this.listItems('ObjectType').find(y => name === y.Extras.Name);
							// On retourne l'objet formaté ou null si pas trouvé
							return item ? { text: item.Label, value: name } : null;
						})
						.filter(opt => opt !== null) // On retire les éventuels éléments non trouvés
						.sort((a, b) => a.text.localeCompare(b.text));
			});
		}

		/**
		 * Met à jour la liste des contraintes selon un type donné
		 * @param type type sélectionné
		 */
		private updateConstraints(type : ListItem){

			console.debug("PropertiesFilter - updateConstraints - type : %O - constraintOptions.length : %O", type.Extras.Name, this.constraintOptions.length)

			// Récupération des contraintes de l'objet sélectionné
			this.getConstraintsLabel(type.Extras.Name).then(async () => {
				console.debug("constraintOptions", this.constraintOptions);
				
				// On met à jour le booléen permettant l'ajout de sous filtres
				this.noSubFilterAvailable = this.constraintOptions.length == 0;

				this.criterias = [];

				// Si le type sélectionné ne peut pas avoir de sous filtres mais que des sous filtres existaient, on les supprime.
				if(this.noSubFilterAvailable && (Object.keys(this.subFilters).length > 0 && this.subFilters.length > 0))
					this.subFilters = [];
			});
		}

		private updateSubFilter(selectedOption : { text: string, value: string }, subFilter : SubFilter, index : number){
			console.debug("PropertiesFilter - updateSubFilter - selectedOption : %O - subFilter : %O - index :%O ", selectedOption, subFilter, index);
			
			subFilter.Type = selectedOption.value;
		}

		/** Ajout d'un nouveau sous-filtre
		 * @param selectType Type d'objet
		 * @param subFilters Liste des sous-filtres
		 */
		private addSubFilter(selectType : ListItem, subFilters : SubFilter[]){
			console.debug("PropertiesFilter - addSubFilter - subFilter", subFilters);

			if (selectType && Object.keys(selectType).length > 0)
			this.getConstraintsLabel(selectType.Extras.Name).then(async () => {
				console.debug("addSubFilter - constraintOptions", this.constraintOptions);

				// On verifie que des contraintes existe pour ajouter un sous-filtre et on met l'opérateur "ET" si au moins un existe
				if(this.constraintOptions.length > 0 )
					subFilters.push({ Type : undefined , Criterias : [], Operande: subFilters.length > 0 ? "And" : "", SubFilters : []});
			}) ;
		}

		/** Suppression d'un sous filtre
		 * @param subFilters liste des sous filtres
		 * @param index index du sous filtre à supprimer
		 */
		private removeSubFilter(subFilters : SubFilter[] , index : number){
			subFilters.splice(index, 1);
		}

		/** Réinitialisation de la liste des filtres par propriétés  */
		private clearPFilter(withPin : boolean = true) {
			if(withPin)
				this.resetPin();
	
			this.selectType = {} as ListItem;
			this.criterias = [];
			this.subFilters = [];
		}

		/** Permet l'ajout ou la mise à jour d'un filtre pour les propriétés d'objet */
		private saveFilter() {
			console.debug("PropertiesFilter - saveFilter - Object.keys(this.lPin).length : %O - this.selectType %O", Object.keys(this.lPin).length, this.selectType);
			let objectType = Object.keys(this.selectType).length > 0 && Object.keys(this.selectType.Extras).length > 0  ? this.selectType.Extras.Name : this.searchPins[0].TreeNode.ObjectType;
			let reference = Object.keys(this.searchPins).length > 0 ? this.searchPins[0].Reference : "";

			// Ajout de la Pin
			if(this.lPin && Object.keys(this.lPin).length > 0) {
				// Mise à jour de la Pin existante
				this.$store.dispatch(this.FilterTreeStore + "/UpdatePin", { id: this.lPin.Id, treeNode: this.lPin.TreeNode, objectType: objectType, criterias : this.criterias, subFilters : this.subFilters })
			}
			else {
				let treeNode = this.searchPins.length > 0 ? this.searchPins[0].TreeNode : undefined;
				objectType = Object.keys(this.selectType).length > 0 && Object.keys(this.selectType.Extras).length > 0  ? this.selectType.Extras.Name : ""; 
				console.debug("PropertiesFilter - saveFilter - type : %O - reference : %O - objectType : %O - criterias %O", this.propertyType, reference, objectType, this.criterias);

				this.$store.dispatch(this.FilterTreeStore + "/AddPin", { included: true, type: this.propertyType, reference: reference, selections: [], text: "", depreciated: false, objectType: objectType, treeNode: treeNode, criterias: this.criterias, subFilters : this.subFilters });					
			}				
		}

		/** Permet de reset la Pin sélectionné apres mise à jour de celle-ci ou fermeture de la fenetre */
		private resetPin(){
			if(this.lPin && Object.keys(this.lPin).length > 0)
				this.lPin = {} as Pin;
		}

		/** Méthode pour la fermeture de la modale */
        private onClose() {
			this.resetPin();
            this.visible = false;
            this.$emit('PropertiesFilterVisibleEvent', this.visible);
        }

		mounted(){
			if(this.lPin && Object.keys(this.lPin).length > 0) {
				console.debug("PropertiesFilter - mounted - lPin.Type : %O", this.lPin.Type);

				if (this.lPin.Filter && Object.keys(this.lPin.Filter).length > 0 )
				{
					if (this.lPin.Filter.ObjectType != "None")	
						this.selectType = this.getObjectLabel().find(o => o.Extras.Name === this.lPin.Filter.ObjectType);

					this.criterias = this.lPin.Filter.Criterias;
					this.subFilters = this.lPin.Filter.SubFilters;
				}

				this.propertyType = this.lPin.Type;

				// On crée une variable pour adapter le texte avec le nom de la TreeNode 
				// pour résoudre le probleme de l'affichage du noeud (TODO : voir pour faire autrement...)				
				if(this.lPin.TreeNode && Object.keys(this.lPin.TreeNode).length > 0) {
					let searchPin = this.lPin;
					searchPin.Text = this.lPin.TreeNode.Name;
					this.searchPins.push(searchPin);
				}

				console.debug("PropertiesFilter - mounted - searchPins : %O - selectType : %O - propertyType : %O", this.searchPins, this.selectType, this.propertyType);

				if (this.selectType && Object.keys(this.selectType).length > 0)
					this.getConstraintsLabel(this.selectType.Extras.Name);
			}
		}

		async created() {
			// Requête le serveur pour obtenir la liste des propriétés par type d'objet si elle n'est pas déjà chargée
			const args: Dictionary<any> = {};
			args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

			await axios.post(API_URL + "FilterTree/GetProperties", args).then((response) => {
				if (response && response.data) {
					this.properties = response.data;
				}
			})
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('AnErrorHasOccured').toString(), { // $t('AnErrorHasOccured') / Une erreur s'est produite.
					title: this.$t('Error').toString(), // $t('Error') / Erreur
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});

		}
	}

</script>

<style scoped >
/** Style pour scroll dans le dropdown */
.dropdownCriteria .dropdown-menu{
	max-height: 6rem !important;
	overflow-y: auto;
}

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
            border-color: var(--Variant) !important;
            background-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>